export interface IJsonMetaData<T> {
  name?: string;
  clazz?: { new (...args: any[]): T };
}

export const JSON_METADATA_KEY = 'jsonProperty';

export function getClazz(target: any, propertyKey: string): any {
  return Reflect.getMetadata('design:type', target, propertyKey);
}

export function getJsonProperty<T>(target: any, propertyKey: string): IJsonMetaData<T> {
  return Reflect.getMetadata(JSON_METADATA_KEY, target, propertyKey);
}
